import { AxiosInstance } from 'axios';

export type ActivityAnalyticsApi = ReturnType<typeof getActivityAnalyticsApi>;

export const getActivityAnalyticsApi = (axiosInstance: AxiosInstance) => {
  const trackEvent = async (
    eventName: string,
    properties: Record<string, unknown> = {}
  ): Promise<void> => {
    await axiosInstance.post('/activity-analytics/track', {
      eventName,
      properties,
    });
  };

  return {
    trackEvent,
  };
};
